export default __webpack_public_path__ + "static/media/board_card_img.d44ffc22.png";